/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 24/08/22
 */

import React from 'react';
import { Tile } from '@/components/Tile';
import { LeaveStats } from '@/components/pages/dashboard/tiles';
import FocusHeader from '@/components/FocusHeader/FocusHeader';
import StateDisplay from '@/components/StateDisplay/StateDisplay';
import { LeaveValues } from '@/components/pages/dashboard/tiles/LeaveTile/LeaveStats';
import { SimpleAlert } from '@/components/SimpleAlert/SimpleAlert';

const LeaveTile = ({ values, loading, error }: { values?: LeaveValues; loading?: boolean; error?: boolean }) => {
    return (
        <Tile
            ariaLabelledBy="Overview-Heading"
            heading={
                <FocusHeader as="h3" id="Overview-Heading" size={'small'} textColor="blue.500">
                    Leave Summary
                </FocusHeader>
            }
            colspan={{ base: 2, lg: 1 }}
            role="landmark"
        >
            <StateDisplay
                loading={!!loading}
                error={!!error}
                data={values}
                errorRender={() => <SimpleAlert variant="subtle">Could not load leave summary</SimpleAlert>}
                render={(stats) => <LeaveStats values={stats} />}
            />
        </Tile>
    );
};

export default LeaveTile;
